import React from 'react';
import IndexSections from '../../components/ufo/index/Index';  // ✅ Fix import

const IndexPage = () => {
  return (
    <>
      <IndexSections />  {/* ✅ Fix component usage */}
    </>
  );
};

export default IndexPage;